import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { debounce } from "lodash";
import {
  Avatar,
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  Input,
  Modal,
  Row,
  Select,
  Switch,
  Table,
  Tooltip,
  message,
  Upload,
} from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  EyeOutlined,
  FileImageOutlined,
  SearchOutlined,
  UploadOutlined,
  ClearOutlined, PlusOutlined,
} from "@ant-design/icons";
import { SetRoute } from "../scripts/action";
import { CheckPermission, PriceFormat, SearchFormat } from "../scripts/helpers";
import { Constants, Permissions } from "../scripts/settings";
import API from "../scripts/api";
import Resources from "../scripts/resources";
import PaginationInfo from "../components/PaginationInfo";
import LogisticsScheduleForm from "../forms/LogisticsScheduleForm";
import moment from "moment-jalaali";
const { TextArea } = Input;

class logisticsSchedulePage extends Component {
  constructor() {
    super();

    this.state = {
      data: [],
      filter: [],
      pagination: {
        total: 0,
        current: 1,
        pageSize: Constants.pageSize,
        size: "small",
      },
      selected: {},
      uploadLoading: false,


      // ///////////////
      filterCountry: undefined,
      filterCity: undefined,
      filterNeighborhood: undefined,
      countries: [], // لیست برای سلکت باکس‌های جستجو
      cities: [],
      neighborhoods: [],

      searchText: "",
      fileList: [],
      searchFile: null,
    };

    this.formRef = React.createRef();
    this.handleFilter = debounce(this.handleFilter, 1000);
  }

  fetch = (params = {}) => {
    const { filterCountry, filterCity, filterNeighborhood } = this.state;

    const query = {
        ...params,
        country_id: filterCountry,
        city_id: filterCity,
        neighborhood_id: filterNeighborhood,
    };
    this.setState({ loading: true });

    API.logisticsSchedule
      .list(query)
      .then((result) => {
        if (result.data) {
          console.log(result.data)
              // اگر فایلی در دیتابیس بود، آن را به لیست اضافه کن
          if (result.setting.logistics_schedule_audio) {
            const fileList = [{
              uid: '-1', // یک آیدی دلخواه و یکتا
              name: 'فایل صوتی فعلی', // اسمی که کاربر می‌بیند
              status: 'done', // وضعیت را done بگذار
              url: Constants.baseUrl + "storage/" + result.setting.logistics_schedule_audio, // آدرس کامل فایل (مثلاً http://site.com/storage/audios/1.mp3)
            }];
            this.setState({
              fileList: fileList,
            })
          }
          this.setState({
            loading: false,
            data: result.data.data,
            searchText: result.setting.logistics_schedule_text,
            pagination: {
              ...this.state.pagination,
              ...{
                current: result.data.current_page,
                pageSize: result.data.per_page,
                total: result.data.total,
              },
            },
          });
        } else {
          this.setState({ loading: false });
        }
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  showModal = (product = {}) => {
    console.log(product);
    this.setState({ visibleModal: true, selected: product });

    setTimeout(() => {
      this.formRef.current.handleDidMount(product);
    }, 0);
  };

  hideModal = () => {
    this.setState({ visibleModal: false });

    setTimeout(() => {
      this.formRef.current.handleWillUnmount();
    }, 0);
  };

  showDrawer = (product = {}) => {
    this.setState({ visibleDrawer: true, selected: product });
  };

  handleFilter = (value, obj) => {
    const state = {};
    state[obj] = value;

    this.setState(state);

    setTimeout(() => {
      this.fetch({ page: 1 });
    }, 0);
  };


  handleDelete = (record) => {
    Modal.confirm({
      title: Resources.confirmDeleteImage,
      okText: Resources.yes,
      okType: "danger",
      cancelText: Resources.no,
      onOk: () => {
        this.setState({ loading: true });

        API.logisticsSchedule
          .delete(record)
          .then((result) => {
            message.success(result.message);

            this.fetch({ page: this.state.pagination.current });
          })
          .catch(() => {
            this.setState({ loading: false });
          });
      },
    });
  };

  handleSubmit = (values) => {
    this.setState({ submitting: true });

    if(this.state.selected.id != undefined){
      API.logisticsSchedule
          .update(values, this.state.selected.id)
          .then((result) => {
            message.success(result.message);
            this.setState({ submitting: false });
            this.hideModal();
            this.fetch({ page: this.state.pagination.current });
          })
          .catch(() => {
            this.setState({ submitting: false });
          });
    }else{
      API.logisticsSchedule
          .store(values)
          .then((result) => {
            message.success(result.message);
            this.setState({ submitting: false });
            this.hideModal();
            this.fetch({ page: this.state.pagination.current });
          })
          .catch(() => {
            this.setState({ submitting: false });
          });
    }

  };

  handleTableChange = (pagination) => {
    this.fetch({ page: pagination.current });
  };

  componentDidMount() {
    const { onSetRoute, routeName, parentName } = this.props;
    const { catId, subCatId } = this.props.match.params;

    onSetRoute({ openKey: parentName, selectedKey: routeName });

    setTimeout(async () => {
      await this.getCountries()
      await this.fetch({ page: 1 });
    }, 0);
  }


  handleFilterChange = (key, value) => {
    const state = { [key]: value };
    
    // اگر کشور عوض شد، شهر و محله پاک شوند
    if (key === 'filterCountry') {
        state.filterCity = undefined;
        state.filterNeighborhood = undefined;
        state.cities = [];
        state.neighborhoods = [];
        if (value) this.getCitiesForFilter(value);
    }
    // اگر شهر عوض شد، محله پاک شود
    if (key === 'filterCity') {
        state.filterNeighborhood = undefined;
        state.neighborhoods = [];
        if (value) this.getNeighborhoodsForFilter(value);
    }

    this.setState(state, () => this.fetch({ page: 1 }));
};

getCountries = () => {
    // فرض بر این است که API.country.list وجود دارد
    API.country.list().then((result) => {
        if (result.data) {
            this.setState({ countries: result.data });
        }
    });
};


  getCitiesForFilter = (countryId) => {
    API.city.list(countryId ).then((result) => {
      this.setState({ cities: result.data || [] });
    });
  };

  getNeighborhoodsForFilter = (cityId) => {
    API.neighborhood.list(cityId ).then((result) => {
      this.setState({ neighborhoods: result.data || [] });
    });
  };


  handleSearchTextChange = (e) => {
    this.setState({ searchText: e.target.value });
  };

  handleFileChange = ({ fileList }) => {
    this.setState({ fileList });
  };

  handleSubmiNotifInfo = () => {
    const { searchText, fileList } = this.state;

    const formData = new FormData();
    formData.append("text", searchText);

    // if (fileList.length > 0) {
    //   formData.append("file", fileList[0].originFileObj);
    // }


    // بررسی وجود فایل جدید
    if (fileList.length > 0) {
        if (fileList[0].originFileObj) {
            // این یعنی کاربر فایل جدید انتخاب کرده است
            formData.append("file", fileList[0].originFileObj);
        } else {
            // این یعنی همان فایل قبلی دیتابیس است
            // نیازی به append کردن فایل نیست، یا می‌توانید یک فلگ بفرستید
        }
    } else {
        // این یعنی کاربر فایل را پاک کرده است
        formData.append("file_deleted", "true");
    }

    API.logisticsSchedule.StorBaseNotifInfo(formData)
      .then(res => res.json())
      .then(result => {
        message.success(result.message);
        console.log(result);
      })
      .catch(err => {
        console.error(err);
      });
  };

  render() {
    const {
      data,
      loading,
      pagination,
      submitting,
      visibleModal,
    } = this.state;

    const columns = [
      {
        title: Resources.country,
        dataIndex: "country",
        className: "col-center",
        render: (val, record) => {
          return val.name;
        },
      },
       {
        title: Resources.city,
        dataIndex: "city",
        className: "col-center",
        render: (val, record) => {
          return val.name;
        },
      },
      {
        title: Resources.neighborhood,
        dataIndex: "neighborhood",
        className: "col-center",
        render: (val, record) => {
          return val?.name;
        },
      },
      {
        title: Resources.dateAndTime,
        dataIndex: "send_date",
        className: "col-ltr",
        render: (val) => moment(val).format(Constants.jDateTimeFormat),
      },

    ];

      columns.push({
        title: Resources.action,
        dataIndex: "id",
        className: "col-center",
        width: "120px",
        render: (val, record) => (
          <Fragment>
           
            <Tooltip title={Resources.edit}>
              <Button
                type="link"
                icon={<EditOutlined />}
                onClick={() => this.showModal(record)}
              />
            </Tooltip>

            <Tooltip title={Resources.delete}>
              <Button
                style={{color:"red"}}
                type="link"
                icon={<DeleteOutlined />}
                onClick={() => this.handleDelete(val)}
              />
            </Tooltip>
      
          </Fragment>
        ),
      });

    return (
      <Fragment>
        <Breadcrumb>
          <Breadcrumb.Item>{Resources.logisticsSchedule}</Breadcrumb.Item>
        </Breadcrumb>
        {/* <div className="ant-content">
          <Row gutter={24}>

          <Col xs={24} md={4}>
              <Button type="primary" icon={<PlusOutlined />} onClick={() => this.showModal()} block>{Resources.add}</Button>
            </Col>
          </Row>
        </div> */}

    <div className="ant-content">
      <Row gutter={24}>

                <Col xs={24} md={10}>
                  <TextArea
                    placeholder="متن اطلاعیه"
                    value={this.state.searchText}
                    onChange={this.handleSearchTextChange}
                    allowClear
                    rows={3}
                  />
                </Col>

                <Col xs={24} md={4}>
                  <Upload
                    beforeUpload={() => false}
                    fileList={this.state.fileList}
                    onChange={this.handleFileChange}
                    maxCount={1}
                    accept="audio/*"
                  >
                    <Button icon={<UploadOutlined />}>انتخاب فایل</Button>
                  </Upload>
                </Col>

                <Col xs={24} md={2}>
                  <Button type="primary" onClick={this.handleSubmiNotifInfo} block>
                    ثبت
                  </Button>
                </Col>

      </Row>
      <hr />

           <Row gutter={16} style={{ marginBottom: 16 }}>
          <Col xs={24} md={4}>
              <Select 
                  placeholder={Resources.country} 
                  allowClear 
                  onChange={(v) => this.handleFilterChange('filterCountry', v)}
                  value={this.state.filterCountry}
                  style={{ width: '100%' }}
              >
                  {this.state.countries.map(c => <Select.Option key={c.id} value={c.id}>{c.name}</Select.Option>)}
              </Select>
          </Col>
          <Col xs={24} md={4}>
              <Select 
                  placeholder={Resources.city} 
                  allowClear 
                  onChange={(v) => this.handleFilterChange('filterCity', v)}
                  value={this.state.filterCity}
                  style={{ width: '100%' }}
              >
                  {this.state.cities.map(c => <Select.Option key={c.id} value={c.id}>{c.name}</Select.Option>)}
              </Select>
          </Col>
          <Col xs={24} md={4}>
              <Select 
                  placeholder={Resources.neighborhood} 
                  allowClear 
                  onChange={(v) => this.handleFilterChange('filterNeighborhood', v)}
                  value={this.state.filterNeighborhood}
                  style={{ width: '100%' }}
              >
                  {this.state.neighborhoods.map(n => <Select.Option key={n.id} value={n.id}>{n.name}</Select.Option>)}
              </Select>
          </Col>
          <Col xs={24} md={2}>
              <Button icon={<ClearOutlined />} onClick={() => {
                  this.setState({ filterCountry: undefined, filterCity: undefined, filterNeighborhood: undefined }, () => this.fetch({ page: 1 }));
              }}>{Resources.clear}</Button>
          </Col>
          <Col xs={24} md={4}>
              <Button type="primary" icon={<PlusOutlined />} onClick={() => this.showModal()} block>{Resources.add}</Button>
          </Col>
      </Row>

</div>
      



   

        <div className="ant-content">
          <Table
            columns={columns}
            dataSource={data}
            loading={loading}
            onChange={this.handleTableChange}
            pagination={pagination}
            size="small"
            rowKey="id"
            scroll={{ x: 936 }}
          />
          {!!pagination.total && (
            <PaginationInfo
              current={pagination.current}
              pageSize={pagination.pageSize}
              total={pagination.total}
            />
          )}
        </div>
     
        <LogisticsScheduleForm
          ref={this.formRef}
          onCancel={this.hideModal}
          onSubmit={this.handleSubmit}
          submitting={submitting}
          visible={visibleModal}
        />
     
      </Fragment>
    );
  }
}

export default connect(
  (state) => {
    return {
      permissions: {
        action: CheckPermission(state.app.user, Permissions.product_option),
      },
    };
  },
  (dispatch) => {
    return {
      onSetRoute: (data) => dispatch(SetRoute(data)),
    };
  }
)(logisticsSchedulePage);
